import Livesearch from 'adeliom-livesearch-js';
import 'adeliom-livesearch-js/dist/livesearch.css';

const livesearchPath = document.querySelector('meta[name="livesearch-path"]');

const getLivesearchPath = () => {
    return livesearchPath.getAttribute('content');
};

if (livesearchPath) {
    const settings = {
        pathAjax: getLivesearchPath(),
        submitSelector: '',
        minimumTimeLoading: 1000,
        paramsInUrl: true,
        animationScrollTo: 'smooth',
        pageKey: 'page',
        handleArraysNatively: true,
        displayFirstPageInUrl: false,
        perPage: 1,
    };

    const livesearch = new Livesearch(settings);

    livesearch.on('beforeChange', () => {
        document.querySelector('[js-livesearch-loading]').classList.remove('hidden');
        document.querySelector('[js-livesearch-results]').classList.add('hidden');
        console.log('beforeChange', window.location.search);
    });

    const originalTitle = document.title.replace(/ - Page \d+/, '');
    const canonicalEl = document.querySelector('link[rel="canonical"]');
    const canonicalBase = canonicalEl
        ? canonicalEl.getAttribute('href').replace(/\?.*$/, '')
        : `${window.location.origin}${window.location.pathname}`;

    livesearch.on('afterChange', () => {
        document.querySelector('[js-livesearch-results]').classList.remove('hidden');
        document.querySelector('[js-livesearch-loading]').classList.add('hidden');
        console.log('afterChange', window.location.search);

        const params = new URLSearchParams(window.location.search);
        const page = parseInt(params.get('page'), 10);

        if (page > 1) {
            const sepIdx = originalTitle.indexOf(' | ');
            document.title = sepIdx !== -1
                ? `${originalTitle.slice(0, sepIdx)} - Page ${page}${originalTitle.slice(sepIdx)}`
                : `${originalTitle} - Page ${page}`;
        } else {
            document.title = originalTitle;
        }

        if (canonicalEl) {
            canonicalEl.setAttribute('href', page > 1 ? `${canonicalBase}?page=${page}` : canonicalBase);
        }
    });

    livesearch.init();
}
